module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('article', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "card_image",
    attrs: {
      "href": _vm.wikiLink
    }
  }, [_c('img', {
    staticClass: "card__img",
    attrs: {
      "src": _vm.animalImage,
      "alt": _vm.species
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "card__species",
    attrs: {
      "href": _vm.wikiLink
    }
  }, [_vm._v(_vm._s(_vm.species))]), _vm._v(" "), _c('p', {
    staticClass: "card__about"
  }, [_vm._v(_vm._s(_vm.about))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0974a3e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 23
// module chunks = 0